import { createActions } from 'reduxsauce';

var _createActions = createActions({
  request: function request() {
    return {
      type: 'MENU_REQUEST'
    };
  },
  response: function response(json) {
    return {
      type: 'MENU_RESPONSE',
      categories: json.categories,
      results: json.results,
      menuType: json.menuType,
      storeId: json.storeId
    };
  },
  categoryChange: function categoryChange(json) {
    return {
      type: 'MENU_CATEGORY_CHANGE',
      currentCategory: json.currentCategory
    };
  },
  featureRequest: function featureRequest() {
    return {
      type: 'MENU_FEATURE_REQUEST'
    };
  },
  featureResponse: function featureResponse(json) {
    return {
      type: 'MENU_FEATURE_RESPONSE',
      features: json.features
    };
  },
  setDefault: function setDefault(json) {
    return {
      type: 'MENU_SET_DEFAULT',
      defaultOptions: json.defaultOptions
    };
  },
  clearDefault: function clearDefault() {
    return {
      type: 'MENU_CLEAR_DEFAULT'
    };
  },
  clearMenu: function clearMenu() {
    return {
      type: 'MENU_CLEAR_MENU'
    };
  },
  requestUpsell: function requestUpsell() {
    return {
      type: 'MENU_REQUEST_UPSELL'
    };
  },
  receiveUpsell: function receiveUpsell(json) {
    return {
      type: 'MENU_RECEIVE_UPSELL',
      features: json.upsell
    };
  }
}, {
  prefix: 'MENU_'
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};